import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const MasikKarVasuliReport = () => {
    const navigate = useNavigate();
    const [selectedMonth, setSelectedMonth] = useState('जानेवारी');

    const months = [
        'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून',
        'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
    ];

    const handleReport = () => {
        navigate('/panipuravtha/monthly-report/print', { 
            state: { 
                month: selectedMonth 
            } 
        });
    };

    return (
        <div className="min-h-screen bg-gray-50 font-poppins flex items-center justify-center p-4">
            <div className="w-full max-w-lg bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                {/* Header */}
                <div className="bg-blue-700 text-white px-6 py-4 flex items-center gap-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-white/20 hover:bg-white/30 p-1.5 rounded-full transition-colors focus:outline-none"
                    >
                        <FiArrowLeft className="w-5 h-5" />
                    </button>
                    <h1 className="text-xl font-bold">मासिक करवसुली अहवाल</h1>
                </div>

                {/* Content */}
                <div className="p-8">
                    <div className="flex items-center justify-center gap-4 mb-6">
                        <label className="text-gray-700 font-medium text-lg">महिना :</label>
                        <select
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            className="border border-blue-400 rounded px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800 w-48 text-lg"
                        >
                            {months.map((month, index) => (
                                <option key={index} value={month}>
                                    {month}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Footer / Action */}
                <div className="bg-blue-800 p-4 flex justify-center">
                    <button
                        onClick={handleReport}
                        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-8 rounded shadow-md transition-colors text-lg"
                    >
                        रिपोर्ट
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MasikKarVasuliReport;
